"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(require("./reducers/index"));

var _epics = _interopRequireDefault(require("./epics"));

var _Routes = _interopRequireDefault(require("./Routes"));

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _default = {
  route: _UrlPathParams.PAGES,
  reducer: _index.default,
  routes: _Routes.default,
  rootEpic: _epics.default
};
exports.default = _default;
module.exports = exports.default;